import { Typography } from '@analytical-alley/ui';
import React from 'react';

export const MediaContributionTooltipContent = ({
    formatNumber,
    mediaContributionTotal,
    previousMediaContributionTotal,
    mediaContributionShare,
}: {
    formatNumber: (val: number) => string;
    mediaContributionTotal: number;
    previousMediaContributionTotal: number;
    mediaContributionShare: number;
}) => {
    const roundedMediaContributionShare =
        Math.round(mediaContributionShare * 100 * 100) / 100;
    const contributionAbsDiff =
        mediaContributionTotal - previousMediaContributionTotal;
    const contributionPercentageDiff =
        Math.round(
            (contributionAbsDiff / previousMediaContributionTotal) * 100 * 100,
        ) / 100;

    return (
        <table>
            <tbody>
                <tr>
                    <td className="pr-2">
                        <Typography className="text-black dark:text-black">
                            Forecasted Media Contribution:
                        </Typography>
                    </td>
                    <td>
                        <Typography className="text-dark dark:text-dark">
                            {formatNumber(mediaContributionTotal)}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <td className="pr-2">
                        <Typography className="text-black dark:text-black">
                            Previous Media Contribution:
                        </Typography>
                    </td>
                    <td>
                        <Typography className="text-dark dark:text-dark">
                            {formatNumber(previousMediaContributionTotal)}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <td className="pr-2">
                        <Typography className="text-black dark:text-black">
                            Change:
                        </Typography>
                    </td>
                    <td className="pr-2">
                        <Typography className="text-dark dark:text-dark">
                            {contributionPercentageDiff}% /{' '}
                            {formatNumber(contributionAbsDiff)}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <td className="pr-2">
                        <Typography className="text-black dark:text-black">
                            Forecasted Media Contribution Share:
                        </Typography>
                    </td>
                    <td>
                        <Typography className="text-dark dark:text-dark">
                            {roundedMediaContributionShare}%
                        </Typography>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
